<template>
  <el-col :lg="24">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        {{ $t("boletos") }}
      </div>
      <el-table :data="tableDataList" style="width: 100%" v-loading="loading">
        <el-table-column type="selection" width="60"></el-table-column>
        <el-table-column sortable prop="customer" :label="$t('cliente')">
          <template slot-scope="scope">
            {{ scope.row.customer }}
          </template>
        </el-table-column>
        <el-table-column prop="value" :label="$t('valor')">
          <template slot-scope="scope">
            {{
              scope.row.value
                | currency("R$ ", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                })
            }}
          </template>
        </el-table-column>
        <el-table-column prop="document" :label="$t('documento')">
        </el-table-column>
        <el-table-column prop="species" :label="$t('especie')">
        </el-table-column>
        <el-table-column prop="duedate" :label="$t('vencimento')">
          <template slot-scope="scope">
            {{ scope.row.duedateAt | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="processingAt" :label="$t('pagamento')">
          <template slot-scope="scope">
            {{ scope.row.processingAt | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="#" width="170">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-download"
              @click="download(scope.row.id)"
              circle
            ></el-button> </template
        ></el-table-column>
      </el-table>
      <div class="bottom clearfix">
        <el-row :gutter="5">
          <el-col :lg="8" style="margin-top: 2px; float: right">
            <el-dropdown>
              <el-button>
                Exportar
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <download-excel :data="tableData"> XLS </download-excel>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </el-col>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import { BilletService } from "@/services/customers/billet.services";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "BilletList",
  props: {
    range: Array,
    customer: String,
    service: String,
  },
  computed: {
    tableDataList() {
      const vm = this;
      return vm.tableData;
    },
  },
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      loading: false,
      filter: "",
      user: {
        type: "1",
      },
    };
  },
  methods: {
    download(id) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      BilletService.pdf(id)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `${id}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      const vm = this;
      vm.loading = true;
      const s = moment(vm.range[0]);
      const f = moment(vm.range[1]);
      BilletService.filter({ 
        customer: vm.customer,
        startedAt: s.format("YYYY-MM-DD"),
        finishedAt: f.format("YYYY-MM-DD")
      })
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.fetchRecords();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
